export const config = {
  //apiUrl: 'http://ctaz.local/api/v1',
  apiUrl: (location.port !== '8081') ? 'https://itinerarios.consorciozaragoza.es/api/v1' : 'http://localhost:8080/api/v1',
  accessToken: 'pk.eyJ1IjoicHJhbWVzIiwiYSI6ImNqdWRxdDJzYzB4eTg0ZW5xZmtoZjQzc3cifQ.T8XCiKJNR8OzIbeF6M24vg'
}

export const icons = {
  baseIcon:{
    className:'mapIcon',
    iconSize: [35, 49],
    iconAnchor: [18, 48],
  },
  normal: (location.port === '8081') ? './src/assets/img/marcador.svg' : 'assets/img/marcador.svg',
  start: (location.port === '8081') ? './src/assets/img/start.svg' :'assets/img/start.svg',
  end: (location.port === '8081') ? './src/assets/img/end.svg' : 'assets/img/end.svg',
  bus: (location.port === '8081') ? './src/assets/img/bus2.svg' : 'assets/img/bus2.svg',
  station: (location.port === '8081') ? './src/assets/img/station.svg' : 'assets/img/station.svg'
}

export const legend ={
  position: 'bottomleft'
}

export const cities = {
  url: (location.port === '8080') ? './src/assets/nucleos.geojson' : 'assets/nucleos.geojson'
}



// WEBPACK FOOTER //
// ./src/_config/dev.config.js